import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const usePermissions = () => {
    const permissions = useSelector((state: RootState) => state.user.userPermissions);

    const canView = (feature: string) => {
        if (!permissions || !feature) {
            return false;
        }
        return !!permissions[feature]?.view;
    };
    const canEdit = (feature: string) => {
        if (!permissions || !feature) {
            return false;
        }
        return !!permissions[feature]?.edit;
    };
    const canCreate = (feature: string) => {
        if (!permissions || !feature) {
            return false;
        }
        return !!permissions[feature]?.create;
    };
    const canDelete = (feature: string) => {
        if (!permissions || !feature) {
            return false;
        }
        return !!permissions[feature]?.delete;
    };

    return { canView, canEdit, canCreate, canDelete };
};
